import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tabsContainer mt-3" }
const _hoisted_3 = { class: "tabContent" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-3" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  class: "scrollListContainer",
  ref: "scrollListContainer"
}
const _hoisted_9 = { class: "col-sm-3" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  class: "scrollListContainer",
  ref: "scrollListContainer"
}
const _hoisted_13 = { class: "col-sm-2" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-sm-2" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-sm-2" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "row mt-4" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "boxTitle" }
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = { class: "boxTitle" }
const _hoisted_26 = { class: "ms-2" }
const _hoisted_27 = {
  class: "scrollListContainer",
  ref: "scrollListContainer"
}
const _hoisted_28 = {
  key: 0,
  class: "scrollListItem"
}
const _hoisted_29 = { class: "d-flex justify-content-between" }
const _hoisted_30 = { class: "text-primary" }
const _hoisted_31 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_qualification = _resolveComponent("qualification")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Stato",
                      text: "Stato"
                    })
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.statuses) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item) => {
                      return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item), 9, _hoisted_7))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.user.statuses]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.statuses.statusHistory, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "scrollListItem",
                      key: i
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("b", null, _toDisplayString(item.value.from) + " → " + _toDisplayString(item.value.to), 1)
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("div", null, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$filters.date(item.date, "DD/MM/yyyy HH:mm")), 1)
                    ]))
                  }), 128))
                ], 512)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Substato",
                      text: "Substato"
                    })
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.statuses.subStatus) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subStatuses, (item) => {
                      return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item), 9, _hoisted_11))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.user.statuses.subStatus]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.statuses.subStatusHistory, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "scrollListItem",
                      key: i
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("b", null, _toDisplayString(item.value.from) + " → " + _toDisplayString(item.value.to), 1)
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", null, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$filters.date(item.date, "DD/MM/yyyy HH:mm")), 1)
                    ]))
                  }), 128))
                ], 512)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Product level",
                      text: "Product level"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.statuses.productLevel) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.user.statuses.productLevel]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Nazione",
                      text: "Nazione"
                    })
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.country) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item) => {
                      return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item), 9, _hoisted_17))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.user.country]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Pagabile",
                      text: "Pagabile"
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_toggler, {
                      modelValue: _ctx.user.isPayable,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.isPayable) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Qualifiche",
                    text: "Qualifiche"
                  })
                ]),
                _createVNode(_component_qualification, {
                  modelValue: _ctx.user,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Scadenze",
                      text: "Scadenze"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addToDo && _ctx.addToDo(...args)))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Nuova",
                        text: "Nuova"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.user.statuses.scadenze.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Nessuna scadenza inserita",
                          text: "Nessuna scadenza inserita"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.statuses.scadenze, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "scrollListItem",
                      key: i
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("b", null, _toDisplayString(item.author.name), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(item.toDoType), 1),
                          _cache[9] || (_cache[9] = _createTextVNode(" - ")),
                          _createElementVNode("b", null, _toDisplayString(_ctx.$filters.date(item.startDate, "DD/MM/yyyy HH:mm")), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, _toDisplayString(item.text), 1),
                      _createElementVNode("div", null, [
                        (item.attachments.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.attachments, (x, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "fs-12"
                              }, [
                                _createElementVNode("a", {
                                  class: "text-primary",
                                  href: x.publicUrl,
                                  target: "_blank"
                                }, _toDisplayString(x.fileName), 9, _hoisted_31)
                              ]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ], 512)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}